// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__28I1D","modalFooterButton":"ModalNotes_modalFooterButton__2cepo"};